module.exports = __webpack_public_path__ + "images/emoji/rice_ball.ae0e3942a0babde2c22f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rice_ball.png
// module id = /I06
// module chunks = 13